import styled from "styled-components";

// Styled component named StyledButton
const StyledUnknownPage = styled.div`
    width: 100%;
    height: 100%;
`;

function UnknownPage() {
  // Use it like any other component.
    return <StyledUnknownPage>UnknownPage</StyledUnknownPage>;
}

export default UnknownPage;